// extracted by mini-css-extract-plugin
module.exports = {"b1jrmkeu":"b1jrmkeu"};